module.exports = __webpack_public_path__ + "static/img/ht.fb289ca0.svg";